import React from 'react'

function Map() {
  return (
    <div>
         <div className="album py-2">
                <div className="container">
                    <div className="row">
                        <iframe className="iframe-fluid mb-2"  height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=Quest%20Diagnostics%20Krishnanagar,%20G/1%20&amp;%2042,%20Kotwali%2042,%2042/G/1%20&amp;%2042/G/4,%20MM%20Ghosh%20Street,%20P.S,%20G/4,%20MM%20Ghosh%20St,%20P.O,%20Krishnanagar,%20West%20Bengal%20741101%20Krishnanagar+(Quest%20Diagnostics%20Krishnanagar,%20G/1%20&amp;%2042,%20Kotwali%2042,%2042/G/1%20&amp;%2042/G/4,%20MM%20Ghosh%20Street,%20P.S,%20G/4,%20MM%20Ghosh%20St,%20P.O,%20Krishnanagar,%20West%20Bengal%20741101)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe> 
                    </div>
                </div>
            </div>
    </div>
  )
}

export default Map